module.exports = __webpack_public_path__ + "img/information_ethical.580ef42.jpg";